import gql from "graphql-tag";

export const UpdatePartner = gql`
  mutation UpdatePartner(
    $Id: ID!
    $Active: Boolean!
    $FirstName: String!
    $LastName: String!
    $MiddleName: String
    $Phone: AWSPhone!
    $Title: PartnerTitle!
    $CallEnabled: Boolean!
    $SmsEnabled: Boolean!
    $ConsentToShare: Boolean!
    $Type: PartnerType
    $OptOutClientApproval: Boolean
  ) {
    UpdatePartner(
      Input: {
        Id: $Id
        Active: $Active
        FirstName: $FirstName
        LastName: $LastName
        MiddleName: $MiddleName
        Phone: $Phone
        Title: $Title
        CallEnabled: $CallEnabled
        SmsEnabled: $SmsEnabled
        ConsentToShare: $ConsentToShare
        Type: $Type
        OptOutClientApproval: $OptOutClientApproval
      }
    ) {
      Id
    }
  }
`;

export const CreatePartner = gql`
  mutation CreatePartner(
    $email: AWSEmail!
    $firstName: String!
    $lastName: String!
    $middleName: String
    $phone: AWSPhone!
    $primaryCognitoUserId: String!
    $primaryUserPoolId: String!
    $Type: PartnerType
    $title: PartnerTitle!
    $CallEnabled: Boolean
    $SmsEnabled: Boolean
    $ConsentToShare: Boolean
    $OptOutClientApproval: Boolean!
  ) {
    CreatePartner(
      Input: {
        PrimaryUserPoolId: $primaryUserPoolId
        PrimaryCognitoUserId: $primaryCognitoUserId
        Phone: $phone
        Email: $email
        FirstName: $firstName
        LastName: $lastName
        Title: $title
        Type: $Type
        MiddleName: $middleName
        CallEnabled: $CallEnabled
        SmsEnabled: $SmsEnabled
        ConsentToShare: $ConsentToShare
        OptOutClientApproval: $OptOutClientApproval
    }
    ) {
      ApplicationStatus
      FirstName
      Id
      LastName
      MiddleName
      Email
      OrganizationId
      Phone
      PrimaryCognitoUserId
      PrimaryUserPoolId
      PhoneExt
      RegistrationCodeId
      Title
      Email
    }
  }
`;

export const GetPartner = gql`
  query GetPartner($PartnerId: ID!) {
    GetPartner(PartnerId: $PartnerId) {
      Active
      ApplicationStatus
      FirstName
      LastName
      MiddleName
      Email
      Phone
      CallEnabled
      SmsEnabled
      Title
      Type
      CallEnabled
      Id
      ConsentToShare
      SmsEnabled
      ReferralCode
      OrganizationId
      OptOutClientApproval
      TaxProfessional {
        Bookkeeping
        DisciplinaryAction
        DisciplinaryActionDesc
        EoCoverage
        EoInsurance
        FilingSoftware
        IrsAudit
        IrsAuditDesc
        Languages
        Licenses
        PrepCompetency
        ReturnForms
        Ptin
        ReturnSchedules
        TaxResolution
        TaxReturnsPrepared
        YearsOfExperience
        Id
      }
    }
  }
`;

export const InitiatePartnerEnrollmentInput = gql`
  mutation InitiatePartnerEnrollmentInput($partnerId: ID!) {
    InitiatePartnerEnrollment(
      Input:{
        PartnerId: $partnerId
      }
      ) {
      PartnerId
      Partner {
        Email
        Id
        OrganizationId
        TaxProfessional {
          Id
        }
      }
      NextEnrollmentAction
      Id
      InitiatedAt
      CancelledAt
      CompletedAt
      Status
      NextForm {
        Id
        Name
        S3Bucket
        S3VersionId
        S3Key
      }
    }
  }
`;

export const CompletePartnerForm = gql`
  mutation CompletePartnerForm($PartnerEnrollmentId: ID $FormId: ID! $PartnerId: ID!) {
    CompletePartnerForm(
      Input: { 
        FormId: $FormId, 
        PartnerId: $PartnerId 
    } 
    PartnerEnrollmentId: $PartnerEnrollmentId
    ) {
      Active
      Id
      Name
      S3Bucket
      S3Key
      S3VersionId
    }
  }
`;